var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 0.75H2.49453C1.53203 0.75 0.75 1.54297 0.75 2.51641V23.4836C0.75 24.457 1.53203 25.25 2.49453 25.25H23.5C24.4625 25.25 25.25 24.457 25.25 23.4836V2.51641C25.25 1.54297 24.4625 0.75 23.5 0.75ZM8.15469 21.75H4.52344V10.0578H8.16016V21.75H8.15469ZM6.33906 8.46094C5.17422 8.46094 4.23359 7.51484 4.23359 6.35547C4.23359 5.19609 5.17422 4.25 6.33906 4.25C7.49844 4.25 8.44453 5.19609 8.44453 6.35547C8.44453 7.52031 7.50391 8.46094 6.33906 8.46094ZM21.7664 21.75H18.1352V16.0625C18.1352 14.7063 18.1078 12.9617 16.2484 12.9617C14.3562 12.9617 14.0664 14.4383 14.0664 15.9641V21.75H10.4352V10.0578H13.9187V11.6547H13.968C14.4547 10.7359 15.6414 9.76797 17.4078 9.76797C21.0828 9.76797 21.7664 12.1906 21.7664 15.3406V21.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c02e69371a01f2075f3abb8b2804aa3d.svg";
export { ForwardRef as ReactComponent };